import { StateService } from '@uirouter/angularjs';
import { ITimeoutService } from 'angular';
import { StateTransitionSucceedAction } from '../app.action';
import ActionAwareController from '../common/actions/action-aware.controller';
import { Action } from '../common/actions/core/action';
import ActionDispatcherService from '../common/actions/core/action-dispatcher.service';
import NotificationService from '../common/services/notification/notification.service';
import GlobalSpinnerService from '../common/services/spinner/global-spinner.service';

/* @ngInject */
export default class MainController extends ActionAwareController {
  private viewContainerElement: JQLite;

  constructor(
    private i18n,
    private $location,
    private $translate,
    private $element: JQLite,
    private $timeout: ITimeoutService,
    private notificationService: NotificationService,
    private globalSpinner: GlobalSpinnerService,
    private $state: StateService,
    actionDispatcher: ActionDispatcherService
  ) {
    super(actionDispatcher);
  }

  public $onInit() {
    this.viewContainerElement = this.$element.find('.view-container');
    super.$onInit();
    const search = this.$location.search().iframe;
    const language = this.$location.search().language;
    if(search) {
      localStorage.setItem('fizyWEB', '1');
    }else if(localStorage.getItem('fizyWEB')){
      localStorage.removeItem('fizyWEB');
    }
    if(language){
      this.$translate.use(language);
      this.$translate.refresh();
    }
  }

  public handle(action: Action) {
    if (action instanceof StateTransitionSucceedAction) {
      this.scrollTop();
    }
  }

  public isSpinnerActivated() {
    return this.globalSpinner.isActivated();
  }

  public headerAndFooterCheck() {

    const checkIFrame = localStorage.getItem('fizyWEB');
    const checkHeaderAndFooter = localStorage.getItem('showInApp');

    if(!checkHeaderAndFooter){
      $("#fizyHeader, #fizyFooter").show();
    }else{
      $("#fizyHeader, #fizyFooter").hide();
    }
    
    return checkIFrame && checkIFrame.length > 0;
  }

  private scrollTop() {
    this.$timeout(() => {
      this.viewContainerElement.scrollTop(0);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/main/main.controller.ts